@if(initialized && agbInfo) {

<span class="info-page-text" [innerHTML]="agbInfo"></span>

}
